import gsap from 'gsap';

export default function initTabs() {
  const classActive = 'is-active';

  function showTab(btn, panel, animate = true) {
    btn.classList.add(classActive);
    btn.setAttribute('aria-selected', 'true');
    panel.classList.add(classActive);
    panel.removeAttribute('aria-hidden');
    panel.removeAttribute('inert');

    if (animate) {
      gsap.killTweensOf(panel);
      gsap.fromTo(panel, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.25 });
    }
  }

  function hideTab(btn, panel) {
    btn.classList.remove(classActive);
    btn.setAttribute('aria-selected', 'false');

    gsap.set(panel, { position: 'absolute', top: 0, left: 0, width: '100%' });
    gsap.killTweensOf(panel);
    gsap.to(panel, { autoAlpha: 0, duration: 0.25, onComplete() {
      panel.classList.remove(classActive);
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
      gsap.set(panel, { clearProps: 'all' });
    }});
  }

  document.querySelectorAll('[data-tabslist]').forEach(tabsList => {
    const tabBtns = tabsList.querySelectorAll('[data-tab]');

    const tabAPI = {
      activeBtn: null,
      activePanel: null,
      tabs: []
    };

    tabBtns.forEach(btn => {
      const target = document.getElementById(btn.dataset.tab);
      if (target) {
        tabAPI.tabs.push({ btn, target });

        if (!tabAPI.activeBtn && btn.classList.contains(classActive)) {
          tabAPI.activeBtn = btn;
          tabAPI.activePanel = target;
        }
      }
    });

    if (!tabAPI.activeBtn && tabAPI.tabs[0]) {
      tabAPI.activeBtn = tabAPI.tabs[0].btn;
      tabAPI.activePanel = tabAPI.tabs[0].target;
      showTab(tabAPI.activeBtn, tabAPI.activePanel, false);
    }

    tabAPI.tabs.forEach(obj => {
      obj.btn.addEventListener('click', () => {
        if (obj.btn === tabAPI.activeBtn) return;

        hideTab(tabAPI.activeBtn, tabAPI.activePanel);
        showTab(obj.btn, obj.target);

        tabAPI.activeBtn = obj.btn;
        tabAPI.activePanel = obj.target;
      });
    });
  });
}
